import { useLocalStorage } from '@karnov/kui-react'
import { useCallback } from 'react'

import { localStorageKeys } from 'consts/localStorageKeys'
import { changeLanguage } from 'services/i18n'

import { Language } from 'types/Api'

type Output = {
  onSetPreferredLanguage: (language: Language) => void
  preferredLanguage: Language | null
}

export const usePreferredLanguage = (): Output => {
  const [storedLanguage, setStoredLanguage] = useLocalStorage<Language | null>(localStorageKeys.preferredLanguage, null)

  const handleSelectLanguage = useCallback(
    (language: Language) => {
      setStoredLanguage(language)
      changeLanguage(language)
    },
    [setStoredLanguage],
  )

  return {
    onSetPreferredLanguage: handleSelectLanguage,
    preferredLanguage: storedLanguage,
  }
}
